import {IUser} from "../../shared/models/user.model";

export const GET_ALL_PROVIDERS_LIST = 'GET_ALL_PROVIDERS_LIST';
export const SET_ALL_PROVIDERS_LIST = 'SET_ALL_PROVIDERS_LIST';
export const GET_SYSTEM_SETTINGS_DETAILS = 'GET_SYSTEM_SETTINGS_DETAILS';
export const SET_SYSTEM_SETTINGS_DETAILS = 'SET_SYSTEM_SETTINGS_DETAILS';

export const getAllProvidersList = () => {
    return {type: GET_ALL_PROVIDERS_LIST};
};

export const setAllProvidersList = (allProvidersList: IUser[]) => {
    return {
        type: SET_ALL_PROVIDERS_LIST, payload: {
            allProvidersList
        }
    };
};

export const getSystemSettingDetails = () => {
    return {type: GET_SYSTEM_SETTINGS_DETAILS};
}

export const setSystemSettingDetails = (systemSettingsDetails: any) => {
    return {
        type: SET_SYSTEM_SETTINGS_DETAILS, payload: {
            systemSettingsDetails
        }
    }
}
